import React from 'react';
import { Table } from 'semantic-ui-react';
import { columnError } from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import SimpleCell from '@/components/table/SimpleCell';

const DataManagementDictionaryErrorTable = ({ error }) => (
  <TableWrapper
    unstackable
    compact
    solid
    sticky
    attached
  >
    <Table.Header>
      <Table.Row>
        <UnsortedColumn columnId={columnError} />
      </Table.Row>
    </Table.Header>
    <Table.Body>
      <Table.Row>
        <SimpleCell content={error} />
      </Table.Row>
    </Table.Body>
  </TableWrapper>
);

export default DataManagementDictionaryErrorTable;
